/**
 * Readable save-button styles for dark Platform Settings pages.
 * Overrides the default Button disabled:opacity-50 which is unreadable on dark backgrounds.
 */

export const PLATFORM_SAVE_BUTTON_BASE =
  'transition-colors disabled:pointer-events-none disabled:opacity-100';

export function platformSaveButtonClassName({ active, saved, inactive }) {
  if (inactive) {
    return `${PLATFORM_SAVE_BUTTON_BASE} bg-zinc-800 text-zinc-400 border border-zinc-600 hover:bg-zinc-800 cursor-not-allowed`;
  }
  if (active) {
    return `${PLATFORM_SAVE_BUTTON_BASE} bg-emerald-600 hover:bg-emerald-500 text-white border border-emerald-500 shadow-sm`;
  }
  if (saved) {
    return `${PLATFORM_SAVE_BUTTON_BASE} bg-zinc-800/95 text-zinc-200 border border-zinc-500 hover:bg-zinc-800 cursor-default`;
  }
  return `${PLATFORM_SAVE_BUTTON_BASE} bg-zinc-800 text-zinc-300 border border-zinc-600 hover:bg-zinc-800`;
}
